

export const frontMatter = {
	sidebar_position: 2
};
export const contentTitle = 'Похідні слова';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-uk-docusaurus-plugin-content-docs-current-learn-vocabulary-derivation-md-c8d.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Праслов&#39;янська",
  "id": "proto-slavic",
  "level": 2
}, {
  "value": "Міжнародна лексика",
  "id": "international-vocabulary",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    header: "header",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, IPA, MDDerivation, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!IPA) _missingMdxReference("IPA", true);
  if (!MDDerivation) _missingMdxReference("MDDerivation", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "похідні-слова",
        children: "Похідні слова"
      })
    }), "\n", _jsx(_components.h2, {
      id: "proto-slavic",
      children: "Праслов'янська"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsxs(_components.p, {
      children: ["Слова засновані на живих слов'янських мовах, і коли останні не узгоджуються між собою, ми в основному йдемо за більшістю, застосовуючи ", _jsx(_components.a, {
        href: "/uk/learn/misc/design-criteria#vocabulary",
        children: "систему голосування"
      }), ". Щоб уникнути неузгодженостей, ми маємо переконатися, що слова, які використовують той самий корінь, завжди використовують його в тій самій формі. Оскільки всі слов’янські мови походять від загальнослов’янської досить передбачуваним шляхом, ми ніколи не запозичуємо з них напряму. Натомість ми дотримуємося моделі простого похідного походження від загальнослов’янської мови. Це робить мову легшою для розпізнавання та зручнішою для всіх. Лише прочитавши кілька текстів, людина автоматично швидко дізнається, як той чи інший звук у її рідній мові подається міжслов’янською."]
    }), "\n", _jsxs(_components.p, {
      children: ["У наведеній нижче таблиці показано, як різні загальнослов’янські звуки та послідовності трактуються міжслов’янською мовою. Зверніть увагу, що в деяких випадках можна розрізнити північнослов’янську та південнослов’янську версії (див. ", _jsx(_components.a, {
        href: "/uk/learn/vocabulary/flavourisation",
        children: "flavourisation"
      }), ")."]
    }), "\n", _jsx(MDDerivation, {}), "\n", _jsx(_components.h2, {
      id: "international-vocabulary",
      children: "Міжнародна лексика"
    }), "\n", _jsx(_components.p, {
      children: "Слов'яни живуть не на острові, і протягом століть їхні мови запозичили багато неслов'янських слів. Частина цих слів була взята від їхніх прямих сусідів (німецької, романської, турецької). Лексика цього типу рідко знаходила свій шлях до всієї мовної родини. Наприклад, німецькі запозичення набагато частіше зустрічаються в західнослов’янській, ніж у російській чи болгарській, тоді як слів турецького походження можна знайти в південнослов’янській мові більше, ніж в інших слов’янських мовах. Як наслідок, більшість цієї лексики не є загальнозрозумілою і тому не використовується в міжслов’янській мові."
    }), "\n", _jsx(_components.p, {
      children: "Інша категорія — це міжнародна лексика, переважно з латинської та грецької, але пізніше також з французької та нещодавно англійської. Слова цього типу, як правило, схожі в Європі та інших частинах світу. Вони є невід'ємною частиною кожної слов'янської мови і можуть бути дуже корисними для досягнення взаємної зрозумілості, особливо серед більш освічених верств населення. Інтернаціональні слова практично ідентичні в кожній мові, і майже немає відмінностей у значенні. Коли ми запозичуємо міжнародну лексику, ми максимально наближаємося до написання оригінального слова, адаптуючи його лише настільки, наскільки цього вимагає орфографія. Однак особливо для греко-латинської лексики йдеться про наступне:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["уникають споріднених приголосних: ", _jsx(_components.em, {
          children: "грамофон"
        }), ", ", _jsx(_components.em, {
          children: "група"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Грецькі приголосні ", _jsx(_components.code, {
          children: "th"
        }), " і ", _jsx(_components.code, {
          children: "ph"
        }), " спрощуються до ", _jsx(_components.code, {
          children: "t"
        }), " і ", _jsx(_components.code, {
          children: "f"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "teatr, fenomen"
          })
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Грецьке ", _jsx(_components.code, {
          children: "y"
        }), " пишеться ", _jsx(_components.code, {
          children: "i"
        }), ", що ближче як до написання, так і до вимови в більшості слов'янських мов: ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "sistem, fizika"
          })
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Звук ", _jsx(IPA, {
          children: "k"
        }), " завжди пишеться ", _jsx(_components.code, {
          children: "k"
        }), " і ніколи ", _jsx(_components.code, {
          children: "c"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "kontakt"
          })
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Звук ", _jsx(IPA, {
          children: "x"
        }), " (часто представлений ", _jsx(_components.code, {
          children: "ch"
        }), ") пишеться ", _jsx(_components.code, {
          children: "h"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "psiholog"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Звук ", _jsx(IPA, {
          children: "y"
        }), " (німецькою пишеться ", _jsx(_components.code, {
          children: "ü"
        }), ", французькою ", _jsx(_components.code, {
          children: "u"
        }), ") перетворюється на ", _jsx(_components.code, {
          children: "ju"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "bjuro"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Між голосними звук ", _jsx(IPA, {
          children: "z"
        }), " (написаний ", _jsx(_components.code, {
          children: "-s-"
        }), ") стає ", _jsx(_components.code, {
          children: "z"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "baza"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Між голосними звук ", _jsx(IPA, {
          children: "s"
        }), " (написаний ", _jsx(_components.code, {
          children: "-ss-"
        }), ") стає ", _jsx(_components.code, {
          children: "s"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "masa"
          })
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Крім того, закінчення передбачувано пристосовані до найбільш поширеного в слов'янських мовах:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Дієслова латинського походження (часто ", _jsx(_components.em, {
          children: _jsxs(_components.strong, {
            children: ["-", _jsx(_components.code, {
              children: "ate"
            }), ", -", _jsx(_components.code, {
              children: "fy"
            }), ", -", _jsx(_components.code, {
              children: "ise"
            }), "/-", _jsx(_components.code, {
              children: "ize"
            })]
          })
        }), " англійською мовою, ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ieren"
          })
        }), " німецькою) мають ", _jsx(_components.code, {
          children: "-ovati"
        }), ": ", _jsx(TransliteratorElement, {
          children: "organizovati"
        }), " , ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "komunikovati"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Латиниця ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ia"
          })
        }), " (англійською мовою передається як ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ia"
          })
        }), " або ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-y"
          })
        }), ") стає ", _jsx(_components.code, {
          children: "-ija"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "ekonomija"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-sis"
          })
        }), " (з грецької) стає ", _jsx(_components.code, {
          children: "-za"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "kriza"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Назви хімічних елементів тощо на ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ium"
          })
        }), " стають ", _jsx(_components.code, {
          children: "-ij"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "helij, kriterij"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Слова на ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-um"
          })
        }), " та ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-us"
          })
        }), " зазвичай мають такі закінчення: ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "forum, korpus"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ty"
          })
        }), " (латиниця ", _jsx(_components.em, {
          children: _jsxs(_components.strong, {
            children: ["-", _jsx(_components.code, {
              children: "tas"
            }), ", -", _jsx(_components.code, {
              children: "tatis"
            })]
          })
        }), ") стає ", _jsx(_components.code, {
          children: "-tet"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "universitet"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ics"
          })
        }), " стає ", _jsx(_components.code, {
          children: "-ika"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "ekonomika"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ism"
          })
        }), " стає ", _jsx(_components.code, {
          children: "-izm"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "komunizm"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ist"
          })
        }), " стає ", _jsx(_components.code, {
          children: "-ist"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "komunist"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-sion"
          })
        }), " стає ", _jsx(_components.code, {
          children: "-zija"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "televizija"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ssion"
          })
        }), " стає ", _jsx(_components.code, {
          children: "-sija"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "diskusija"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійська ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-tion"
          })
        }), " стає ", _jsx(_components.code, {
          children: "-cija"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "akcija"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Прикметники, що походять від цих іменників, мають закінчення ", _jsx(_components.code, {
          children: "-ijny"
        }), ": ", _jsx(TransliteratorElement, {
          children: "televizijny"
        }), ", ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "tradicijny"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійські прикметники в ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-al"
          })
        }), " (лат. ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-alis"
          })
        }), ") закінчуються на ", _jsx(_components.code, {
          children: "-alny"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "neutralny"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійські прикметники на ", _jsx(_components.em, {
          children: _jsxs(_components.strong, {
            children: ["-", _jsx(_components.code, {
              children: "ic"
            }), ", -", _jsx(_components.code, {
              children: "ical"
            })]
          })
        }), " (лат. ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-icus"
          })
        }), ") мають закінчення ", _jsx(_components.code, {
          children: "-ičny"
        }), ": ", _jsx(TransliteratorElement, {
          children: "specifičny"
        }), ", ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "komičny"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійські прикметники в ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ive"
          })
        }), " (лат. ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ivus"
          })
        }), ") мають закінчення ", _jsx(_components.code, {
          children: "-ivny"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "pozitivny"
          })
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Англійські прикметники в ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-ous"
          })
        }), " (лат. ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "-osus"
          })
        }), ") мають закінчення ", _jsx(_components.code, {
          children: "-ozny"
        }), ": ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "seriozny"
          })
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Більш проблематичними є слова, запозичені з англійської мови. При написанні латинським алфавітом ми можемо зберегти оригінальне написання (", _jsx(_components.em, {
        children: "bypass"
      }), ", ", _jsx(_components.em, {
        children: "knockout"
      }), ", ", _jsx(_components.em, {
        children: "jazz"
      }), ", ", _jsx(_components.em, {
        children: "teenager"
      }), "). Проте багато текстів на міжслов’янській мові пишуться кирилицею або обома орфографіями паралельно, часто за допомогою програми транслітерації, і звичайно слід уникати написання ", _jsx(_components.em, {
        children: "бипасс"
      }), " або ", _jsx(_components.em, {
        children: "кноцкоут"
      }), " кирилицею! Тому в більшості випадків ми воліємо застосувати більш фонетичний підхід: ", _jsx(TransliteratorElement, {
        children: "bajpas"
      }), ", ", _jsx(TransliteratorElement, {
        children: "nokaut"
      }), ", ", _jsx(TransliteratorElement, {
        children: "džaz"
      }), ", ", _jsx(TransliteratorElement, {
        children: "tinejdžer"
      }), ", ", _jsx(TransliteratorElement, {
        children: "budžet"
      }), ", ", _jsx(TransliteratorElement, {
        children: "biznes"
      }), ", ", _jsx(TransliteratorElement, {
        children: "mjuzikl"
      }), ", ", _jsx(TransliteratorElement, {
        children: "futbol"
      }), ", ", _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "koktejl"
        })
      }), " тощо."]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

